import { ActionButton, ActionButtonProps } from 'modules/ui/atoms/ActionButton'
import useFlow from '../../../state/use-flow'
import { trackFormSubmitEvent } from '../../../../analytics/helpers/track-form-events'
import useOrder from '../../../../order/state/order/use-order'
import { getClassySessionId } from 'modules/utils/getClassySessionId'

export type PaymentSelectionButtonProps = ActionButtonProps

const PaymentSelectionButton = (props: PaymentSelectionButtonProps) => {
  const flow = useFlow()
  const order = useOrder()

  const onNext = () => {
    trackFormSubmitEvent(flow.currentStep.name, { payment_type: order.paymentDetails.type })

    if (window.newrelic) {
      window.newrelic.addPageAction('payment_method_selected', {
        'classy-session-id': getClassySessionId(),
        paymentMethod: order.paymentDetails.type,
      })
    }

    flow.nextStep && flow.goToStep(flow.nextStep.name)
  }

  return <ActionButton onClick={onNext} {...props} />
}

export default PaymentSelectionButton
